/******************************************************************************************
 *
 * this interceptor will be used to for every 'routes' which includes interceptor
 *
 **************************************************************************************/

import axios from 'axios'
import {auth} from "../auth/index";
import urls from "./whitelisted-api";

axios.interceptors.request.use((config) => {
    // config.withCredentials = false;
    /**
     * not adding headers to whitelisted urls defined in 'whitelisted-api.json'
     *
     */

    Object.keys(urls).forEach((key) => {
        urls[key].forEach((val) => {
            if (config.url === `${process.env.REACT_APP_URL}${key}/${val}`) {
                console.log("not adding Authorization header");
                return config;
            }
        })
    });
    const storedValue = localStorage.getItem('token');
    if (storedValue) {
        config.headers["access-token"] = storedValue
    }
    const csrf = auth.getInstance().getCsrfToken();
    if (csrf) {
        config.headers["X-CSRF-TOKEN"] = csrf;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
axios.interceptors.response.use((response) => {
    // Do something with response data
    return response;
}, (error) => {
    // Do something with response error
    if (error?.response?.status === 401) {

        window.location = "/external/login";
    }
    return Promise.reject(error);
});
